import moment from "moment";

export const getInitials = (name) => {
  if (!name.trim()) return null;

  const nameParts = name.trim()?.split(" ");
  if (nameParts) {
    const initials = nameParts[0][0] + nameParts[nameParts.length - 1][0];
    return initials.toUpperCase();
  }
};

export const qs = (params) => {
  if (!params || typeof params !== "object") return "";
  const queryString = new URLSearchParams(params).toString();
  return queryString ? `${queryString}` : "";
};

export const formatDate = (date, format = "DD-MM-YYYY, hh:mm A") => {
  if (!date || !moment(date).isValid()) return null;
  return moment(date).format(format);
};

export const formatePrice = (number) => {
  if (!number) return "$ 0";
  const formattedNumber = Number(Math.abs(number)).toFixed(2);
  return `$ ${formattedNumber}`
};

export const colors = {
  primary: { textColor: "#00727D", bgColor: "#E6F1F3" },
  secondary: { textColor: "#00BAD1", bgColor: "#D6F4F8" },
  success: { textColor: "#28C76F", bgColor: "#DDF6E8" },
  error: { textColor: "#FF4C51", bgColor: "#FFE2E3" },
  warning: { textColor: "#FF9F43", bgColor: "#FFF0E1" },
  info: { textColor: "#364153", bgColor: "#F3F4F6" },
};
 